<template>
  <div>
    <div class="card p-2 text-center" style="min-height: calc(100vh - 185px); display: flex; flex-direction: column; justify-content: center; align-items: center;">
      
      <div v-if="paymentStatus === 'success'">
        <i class="fas fa-check-circle text-success" style="font-size: 5rem;"></i>
        <h2 class="mt-2 text-success">Payment Successful!</h2>
        <p>Your payment has been completed successfully.</p>
        <p class="text-muted" v-if="tranId">Receipt Reference: {{ tranId }}</p>
      </div>
      
      <div v-if="paymentStatus === 'fail'">
        <i class="fas fa-times-circle text-danger" style="font-size: 5rem;"></i>
        <h2 class="mt-2 text-danger">Payment Failed!</h2>
        <p>We could not process your payment.</p>
      </div>
      
      <div v-if="paymentStatus === 'cancel'">
        <i class="fas fa-exclamation-circle text-warning" style="font-size: 5rem;"></i>
        <h2 class="mt-2 text-warning">Payment Cancelled</h2>
        <p>You have cancelled the payment process.</p>
      </div>
      
      <div v-if="paymentStatus !== 'success' && paymentStatus !== 'fail' && paymentStatus !== 'cancel'">
        <i class="fas fa-exclamation-triangle text-danger" style="font-size: 5rem;"></i>
        <h2 class="mt-2 text-danger">Payment Error</h2>
        <p>{{ message || 'An unknown error occurred during the payment.' }}</p>
      </div>

      <button @click="handleDone" :disabled="isLoading" class="btn btn-primary mt-2 px-5">
        <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span v-if="!isLoading">Done</span>
      </button>

    </div>
  </div>
</template>

<script setup>
import { computed, inject, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import handlePurchaseAndSales from "@/services/modules/purchase";
import moneyReceiptHelper from "@/services/utils/pdf/moneyReceiptHelper";
import handleCompany from "@/services/modules/company";

const route = useRoute();
const router = useRouter();
const showError = inject('showError');

const paymentStatus = computed(() => Array.isArray(route.query.payment_status) ? route.query.payment_status[route.query.payment_status.length - 1] : route.query.payment_status);
const message = computed(() => Array.isArray(route.query.message) ? route.query.message[route.query.message.length - 1] : route.query.message);
const receiptId = computed(() => Array.isArray(route.query.receipt_id) ? route.query.receipt_id[route.query.receipt_id.length - 1] : route.query.receipt_id);
const tranId = computed(() => Array.isArray(route.query.tran_id) ? route.query.tran_id[route.query.tran_id.length - 1] : route.query.tran_id);

const isLoading = ref(false);

const { fetchMoneyReceipt } = handlePurchaseAndSales();
const { generatePdf } = moneyReceiptHelper();
const { fetchCompanyInfo } = handleCompany();

const handleDone = async () => {
  if (paymentStatus.value === 'success' && receiptId.value) {
    isLoading.value = true;
    try {
      const companyQuery = `?company_id=${route.params.companyId}`;
      const companyRes = await fetchCompanyInfo(route.params.companyId);
      let companyInfo = {};
      if (companyRes.status) {
        companyInfo = companyRes.data;
      }
      
      const receiptRes = await fetchMoneyReceipt(receiptId.value, companyQuery);
      if (receiptRes && receiptRes.status) {
        generatePdf(companyInfo, receiptRes.data);
      } 
      if (!receiptRes || !receiptRes.status) {
        showError("Could not generate receipt PDF.");
      }
    } catch (err) {
      console.error("Error generating PDF:", err);
      showError("An error occurred while generating the receipt.");
    } finally {
      isLoading.value = false;
    }
  }

  const today = new Date().toISOString().split('T')[0];
  
  router.push({
    name: 'pending-money-receipt',
    params: {
      companyId: route.params.companyId,
      moduleId: route.params.moduleId,
      menuId: route.params.menuId,
      pageId: route.params.pageId
    },
    query: {
      tab: 'receipt',
      payment_status: 'paid',
      start: today,
      end: today
    }
  });
};
</script>
